<template>
    <Avatar class="MyAvatar" :avatar="picture" />
</template>

<script>
import Avatar from './Avatar';

export default {
    components: { Avatar },
    computed: {
        picture() {
            return this.$store.getters['moduleAuth/avatar'];
        }
    }
};
</script>
